import { InfoCommand } from "slotworks/commands/error/info-command";
import Currency from "slotworks/i18n/currency";
import Translations from "slotworks/i18n/translations";

export function MaxBetMessageCommand(maxStake: number) {
    // TODO: This should be configured on, and should not change it's behaviour based on the presence of a translation
    const maxBetMessage = Translations.get("gen.mbw", { total_bet: Currency.format(maxStake), totalbet: Currency.format(maxStake)});
    if (maxBetMessage !== "gen.mbw") {
        InfoCommand(maxBetMessage).execute();
    }
}



// WEBPACK FOOTER //
// ./~/ifdef-loader/ifdef-loader.js??ref--0-1!./~/slotworks/commands/betbar/max-bet-message-command.ts